import { useState, useEffect, createContext, useContext } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const ImageContext = createContext({});

export const ImageProvider = ({ children }) => {
  const [images, setImages] = useState({});

  useEffect(() => {
    fetch(`${API}/api/site-images`)
      .then(r => r.json())
      .then(data => setImages(data))
      .catch(() => {});
  }, []);

  return <ImageContext.Provider value={images}>{children}</ImageContext.Provider>;
};

export const useImages = () => useContext(ImageContext);

// Get image with fallback
export const useImage = (slug, fallback) => {
  const images = useImages();
  return images[slug] || fallback;
};
